<template>
    <div class="column">
        <div class="card tilebox-one">
            <div class="card-body">
                <i class="dripicons-basket float-end text-muted"></i>
                <h6 class="text-muted text-uppercase mt-0">Non Billable CO's</h6>
                <h2 class="m-b-20">$<animated-number :value="+nonBillableCurrent" /></h2>
                <span class="badge" :class="{'bg-primary' : previousNonBillablePercent <= 0, 'bg-alert' : previousNonBillablePercent > 0}"> <animated-number :value="+previousNonBillablePercent" />%</span> <span class="text-muted">From previous</span>
            </div>
        </div>
    </div>
</template>
<script>
    import AnimatedNumber from '../../../../components/AnimatedNumber'
    import {mapGetters, mapActions} from 'vuex'

    export default {
        components: {
            AnimatedNumber
        },
        props: {
            params: null,
            user: null,
            value: null
        },
        data() {
            return {
                nonBillableData: {
                    current: {},
                    previous: {}
                },
                syncTimeout: null
            }
            
        },
        mounted() {
            this.fillData();
        },
        watch: {
            'params'(value) {
                this.fillData()
            },
            'paramsPrevious' (value) {
                this.fillData()
            },
            'nonBillableData.current' (value) {
                this.$emit('input', this.billingObject)
            },
            'nonBillableData.previous' (value) {
                this.$emit('input', this.billingObject)
            },
        },
        methods: {
            ...mapActions(['getNonbillablevalue']),
            fillData() {
                if (this.syncTimeout) {
                    clearTimeout(this.syncTimeout)
                }

                this.syncTimeout = setTimeout(() => {
                    this.getNonbillablevalue(this.params).then(p => {
                        this.nonBillableData.current = p.data[0]
                        this.nonBillableData.previous = p.data[1]
                    })
                }, 250)
                
            },
            calcPercent(a, b) {
                return Math.round((a / b) * 1000) /10
            }
        },
        computed: {
            billingObject() {
                return { nonBillableData: this.nonBillableData, nonBillableCurrent: this.nonBillableCurrent, previousNonBillablePercent: this.previousNonBillablePercent }
            },
            currentPeriod() {
                return moment().year(this.year).month(this.month - 1).date(1)
            },
            previousPeriod() {
                return this.currentPeriod.subtract('months', 1)
            },
            currentYear() {
                return this.currentPeriod.format('YYYY')
            },
            currentMonth() {
                return this.currentPeriod.format('MM')
            },
            nonBillableCurrent() {
                return (isFinite(this.nonBillableData.current) ? this.nonBillableData.current : 0)
            },
            previousNonBillablePercent() {
                let diff = +this.nonBillableCurrent - +this.nonBillableData.previous
                let curr = this.calcPercent(diff, +this.nonBillableCurrent) 
                return curr ? curr : +this.nonBillableData.previous > 0 ? -100 :  0
            }
        }
    }
</script>